/**
 * This directive is used to implement the no-flicker functionality as suggested by Google Optimize
 * Place the ng-no-flicker directive on whatever elements are modified by Google Optimize
 * and they will be hidden until Google Optimize loads and they are ready for display
 */
const ngNoFlicker = [function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            scope.$on('google:toggleExperiments', (event, data) => {
                element.toggleClass('no-flicker', !data);
            });
        }
    }
}];

export default ngNoFlicker;
